/**
  * ajax请求函数模块
  */
import axios from 'axios'
import { showFullScreenLoading, tryHideFullScreenLoading } from '../common/js/loading' // loading
import { showMessage } from '../common/js/message'
import Bridge from '@/common/js/js-bridge-v2'
import store from '@/views/index/store'

const API_VERSION_PROD = '/server-api/v1'
const API_VERSION_DEV = '/v1'
const BASE_URL = process.env.NODE_ENV === 'production' ? API_VERSION_PROD : '/server-api' + API_VERSION_DEV

// 创建axios实例
const ajax = axios.create({
  baseURL: BASE_URL,
})

// 请求拦截器
ajax.interceptors.request.use(config => {
  if (config.params.showLoading) {
    showFullScreenLoading()
  }
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  config.headers['X-Real-IP'] = '127.0.0.1'
  const token = store.state.userInfo.token || sessionStorage.getItem('token')
  if (token) {
    config.headers.common['token'] = token
  }

  config.showLoading = config.params.showLoading
  let params = config.params
  delete params['showLoading']
  config.params = Object.assign({}, params)
  return config
}, error => { // 请求错误处理
  return Promise.reject(error)
})

// 回复拦截器
ajax.interceptors.response.use(
  response => { // 成功请求到数据
    if (response.config.showLoading) {
      tryHideFullScreenLoading()
    }
    // 这里根据后端提供的数据进行对应的处理
    if (response.config.url.indexOf('/frameworks/systems/user/security') > -1) {
      // 保存token
      let token = response.headers.token
      sessionStorage.setItem('token', token)

      let userInfo = store.state.userInfo
      userInfo.token = token

      store.commit('setUserInfo', userInfo)
    }

    if (response.status === 200) {
      if (response.headers['content-type'].indexOf('application/json') > -1 && response.data.success) {
        return response
      } else if (response.headers['content-type'].indexOf('application/x-zip-compressed') > -1) {
        downloadFile(response)
      } else {
        console.error(response.data.message || '网络异常', 'error')
        if (response.data.message) {
          showMessage(response.data.message)
        }
        
        return response
      }
    } else {
      console.error('网络异常', 'error')
      return Promise.reject(response)
    }
  },
  error => { // 响应错误处理
    let errorStatus = error.response.status
    if (errorStatus&&errorStatus === 666) {
      console.error('登录超时，请重新登录', 'warning')
      // 登录
    } else if (errorStatus >= 500 && errorStatus < 600) {
      console.error('服务器忙碌，请稍后', 'error')
    } else if (errorStatus >= 400 && errorStatus < 500) {
      console.error('客户端忙碌，请稍后', 'error')
    }
    return Promise.reject(error)
  }
)
const upload = (url, file) => {
  let formData = new FormData();
  // 通过 append 向 form 对象添加数据
  formData.append('file', file);
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
/**
 * 下载文件
 * @param response
 */
const downloadFile = (response) => {
  let blob = response.data
  let reader = new FileReader()
  reader.readAsDataURL(blob)
  reader.onload = (e) => {
    let a = document.createElement('a')
    a.style.display = 'none'
    a.download = 'fileName'
    a.href = e.target.result
    a.setAttribute('download', 'generator.zip')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export default {
  BASE_URL,
  upload: upload,
  /**
   * 请求方法
   * @param url
   * @param method 方法名
   * @param params 参数
   * @param config 配置
   * @returns {Promise<any>}
   */
  request (url, method = 'get', params = {}, config = {}) {
    let ajaxConfig = {
      method: method,
      url,
      ...config
    }

    let ajaxParams = {
      showLoading: config.showLoading ? config.showLoading : false,
      ...params
    }

    if (method === 'get' || method === 'GET') {
      ajaxConfig = {
        ...ajaxConfig,
        params: ajaxParams
      }
    } else {
      ajaxConfig = {
        ...ajaxConfig,
        data: params,
        params: {
          showLoading: config.showLoading ? config.showLoading : false
        }
      }
    }
    return new Promise((resolve, reject) => {
      ajax(ajaxConfig).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}
